export interface IVIPCertificatePipelineWorkDepth {
	below350?: string;
	between350and550?: string;
	above550?: string;
}

export function createCertificatePipelineWorkDepth(): IVIPCertificatePipelineWorkDepth {
	return {
		below350: "",
		between350and550: "",
		above550: "",
	}
}

export function checkCertificatePipelineWorkDepth(data: IVIPCertificatePipelineWorkDepth) {
	if (data.below350 === undefined) {
		data.below350 = "";
	}
	if (data.between350and550 === undefined) {
		data.between350and550 = "";
	}
	if (data.above550 === undefined) {
		data.above550 = "";
	}
}
